import { Home } from "views/website/home";
import { Contact } from "views/website/contact";
import { Pricing } from "views/website/pricing";
import { Terms } from "views/website/terms";
import { Privacy } from "views/website/privacy";

const Routes = [
  {
    path: "/",
    view: Home,
    layout: "home",
    title: "Tyro - Catholic Ai",
  },
  {
    path: "/contact",
    view: Contact,
    layout: "auth",
    title: "Contact",
  },
  {
    path: "/pricing",
    view: Pricing,
    layout: "docs",
    title: "Pricing",
  },
  {
    path: "/privacy",
    view: Privacy,
    layout: "docs",
    title: "Privacy Policy",
  },
  {
    path: "/terms",
    view: Terms,
    layout: "docs",
    title: "Terms & Conditions",
  },
];

export default Routes;
